var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "assets-container" },
    [
      _c("page-layout", [
        _c(
          "div",
          { staticClass: "wallet-account-wrapper" },
          [
            _c("account-head", { staticClass: "account_head" }),
            _vm._v(" "),
            _c("TokenFilter", {
              on: {
                newFilter: function(val) {
                  _vm.filterObj = val
                }
              }
            }),
            _vm._v(" "),
            _c("token-list-view", { attrs: { tokenList: _vm.tokenList } })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }